// /components/routes/Dashboard/ClientHeader.tsx
import React from 'react';
import '../../../styles/components/Dashboard.scss';

interface ClientHeaderProps {
  name: string;
  logoUrl?: string;
}

const ClientHeader: React.FC<ClientHeaderProps> = ({ name, logoUrl }) => {
  return (
    <div className="dashboard-header">
      <div className="greeting">
        <h1>Welcome Back, {name || 'Valued Client'}</h1>
        <p>Here's an overview of your store performance and customer insights.</p>
      </div>
      {logoUrl && (
        <img
          src={logoUrl}
          alt="Client Logo"
          className="client-logo"
        />
      )}
    </div>
  );
};

export default ClientHeader;
